<template>
  <div class="lesson-container">
      <h3>Lesson One: Introduction to Turkish</h3>
      <p>Turkish is the official language of the Republic of Turkey. In Turkish it is called Türkçe. Turkish is part of the Turkic language family within the Altaic language group. Turkish is spoken in Turkey, Cyprus, and elsewhere in Europe and the Middle East, as well as diaspora communities around the world.</p>
  </div>
</template>

<script>
export default {
  name: "TurkishLessonTwo",
  props: {
      currentLanguage: {type: String},
  },
  data() {
    return {
     
    };
  },
  methods: {
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
